// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"fc8928d1","818":"b12dd909"}[chunkId] + ".chunk.js";
};